import React from "react";
import Auth0LoginButton from "./Auth0LoginButton";
import Auth0SetupHint from "./Auth0SetupHint";
import { AUTH0_SOCIAL_LOGIN_BUTTONS } from "./config";

const orContinueDividerStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  width: "100%",
  marginBottom: 8,
};

const orContinueLineStyle = {
  flex: 1,
  border: 0,
  borderTop: "1px solid #dadce0",
  margin: 0,
};

const orContinueLabelStyle = {
  fontSize: 13,
  color: "#666",
  whiteSpace: "nowrap",
  fontWeight: 500,
};

/**
 * Social login buttons from `REACT_APP_AUTH_CONNECTION` (same list as `/login`).
 *
 * @param {object} props
 * @param {string} [props.userableType]
 * @param {boolean} [props.rememberMe]
 * @param {number} [props.marginTop]
 * @param {number} [props.marginBottom]
 * @param {"stacked" | "inline"} [props.layout] — `inline`: “Or continue with” + icon row (sign-up forms).
 */
export default function Auth0SocialLoginTiles({
  userableType,
  rememberMe = false,
  marginTop = 14,
  marginBottom = 0,
  layout = "stacked",
}) {
  const entries = AUTH0_SOCIAL_LOGIN_BUTTONS;
  if (entries.length === 0) {
    return <Auth0SetupHint />;
  }

  if (layout === "inline") {
    return (
      <>
        <div
          style={{
            width: "100%",
            marginTop,
            marginBottom,
          }}
        >
          <div style={orContinueDividerStyle}>
            <hr style={orContinueLineStyle} />
            <span style={orContinueLabelStyle}>Or continue with</span>
            <hr style={orContinueLineStyle} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
              width: "100%",
            }}
          >
            {entries.map((entry) => (
              <Auth0LoginButton
                key={entry.id}
                rememberMe={rememberMe}
                userableType={userableType}
                label={entry.label}
                connection={entry.connection}
                variant={entry.variant}
                tileDisplay="icon"
              />
            ))}
          </div>
        </div>
        <Auth0SetupHint />
      </>
    );
  }

  return (
    <>
      <div
        style={{
          width: "100%",
          marginTop,
          marginBottom,
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {entries.map((entry) => (
          <Auth0LoginButton
            key={entry.id}
            rememberMe={rememberMe}
            userableType={userableType}
            label={entry.label}
            connection={entry.connection}
            variant={entry.variant}
          />
        ))}
      </div>
      <Auth0SetupHint />
    </>
  );
}
